<template lang="html">


    <div class="wrapper margin-menu">
  
      <section class="intro column-center -colabora -small">
      </section>
  
      <section class="breadcrumb">
        <nav class="container row-end">
          <router-link to="/">Inicio</router-link>
          <router-link :to="$t('enlaces.colabora')">Colabora</router-link>
        </nav>
      </section>
  
      <main>

        <div class="container gracias-container">
            <h2 class="big-title left">Gracias</h2>
            <h3 class="title-intro -small">Gracias a tu donativo podremos seguir acercando el agua a <strong>aquellos que más lo necesitan</strong></h3>
            <div class="contenedor-texto row-start ais">
                <div class="imagen column-center">
                  <img src="/static/img/corazon-gracias.svg" alt="imagen corazon gracias">
                    <img src="/static/img/molino-rojo.svg" alt="Molino rojo">
                </div>
                <div class="texto" v-if="$route.params.id == 'transferencia'">
                    <p>Por favor realiza tu ingreso a la cuenta de la FUNDACIÓN TOMÁS PASCUAL Y PILAR GOMEZ CUÉTARA:</p>
                    <h3>Número de cuenta: <strong>IBAN ES48 0030 6341 2100 0035 3271</strong></h3>
                    <h3>Concepto: <strong>Indica tu DNI o nombre y apellidos </strong></h3>
                    <p>Muchas gracias por tu colaboración. </p>
                </div>

                <div class="texto" v-if="$route.params.id == 'tarjeta'">
                  <p><strong>¡El pago se ha realizado correctamente!</strong></p>
                  <!-- <h3>Tarjeta de crédito: <strong>**** **** **** ***** 1234</strong></h3> -->
                  <p>Si necesitas ponerte en contacto con nosotros puedes hacerlo <router-link :to="$t('enlaces.contacto')">aquí</router-link></p>
              </div>
            </div>
        </div>

        <proyectos-finalizados></proyectos-finalizados>
  

      </main>
  
    </div>
  
  </template>
  
  <script lang="js">
  
     
  import proyecto from '@/components/parts/proyecto';

  import proyectosfinalizados from '@/components/parts/projects-finalizados';


import {mapGetters} from 'vuex'

export default {
  name: 'colabora',
  components : {
    'proyecto-el' : proyecto,
    'proyectos-finalizados' : proyectosfinalizados,
  },
  computed:{
    ...mapGetters({
      projects : 'getProjectsNotfinish'
    })
  }
}
    </script>
  


// WEBPACK FOOTER //
// src/components/views/gracias-pago.vue